import { useMemo, useSyncExternalStore } from 'react';
import type { LobbySession } from './LobbySession.js';
import type { DiscussionView } from '../discussion/types.js';

export interface UseDiscussionSessionResult {
  /** Non-null only while the session is in the Discussion phase. */
  view: DiscussionView | null;
  /** Reports a tapped cell id (player id or ANOTHER_ROUND). Re-tapping the
   *  current target clears the vote (sends an empty targetId). */
  onVote: (targetId: string) => void;
}

export function useDiscussionSession(session: LobbySession): UseDiscussionSessionResult {
  const snapshot = useSyncExternalStore(
    (cb) => session.subscribe(cb),
    () => session.getSnapshot(),
  );
  const onVote = useMemo(
    () => (targetId: string) => {
      // Toggle-clear lives here (the grid only reports the tap). Read the freshest
      // snapshot at click-time so a stale closure can't mis-toggle.
      const dv = session.getSnapshot().discussionView;
      const current = dv ? dv.votes.get(dv.meId) : undefined;
      session.sendChangeVote(current === targetId ? '' : targetId);
    },
    [session],
  );
  return { view: snapshot.discussionView, onVote };
}
